import { createFileRoute } from "@tanstack/react-router";
import { PosVNextLP } from "@/components/posvnext/PosVNextLP";
import rafaelFoto from "@/assets/orto/prof-rafael.jpg.asset.json";

const TITLE = "Especialização em Dor para Fisioterapeutas | Versão B | FEO";
const DESC =
  "Versão B da LP: pós-graduação 100% online em Dor para Fisioterapeutas. 14 módulos, 360h, reconhecida pelo MEC. Raciocínio em dor baseado em evidências.";
const URL = "https://fisioemortopedia.com.br/dor2";

export const Route = createFileRoute("/dor2")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESC },
      { property: "og:url", content: URL },
      { property: "og:type", content: "website" },
      { name: "robots", content: "noindex" },
    ],
    links: [{ rel: "canonical", href: URL }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Course",
          name: "Especialização em Dor para Fisioterapeutas",
          description: DESC,
          url: URL,
          provider: {
            "@type": "Organization",
            name: "Fisio em Ortopedia (FEO)",
            sameAs: "https://fisioemortopedia.com.br",
          },
          educationalCredentialAwarded: "Especialização (Pós-Graduação Lato Sensu)",
          hasCourseInstance: {
            "@type": "CourseInstance",
            courseMode: "online",
            courseWorkload: "PT360H",
          },
        }),
      },
    ],
  }),
  component: DorLP2,
});

function DorLP2() {
  return (
    <PosVNextLP
      product="dor"
      heroEyebrow="Especialização · 100% online · MEC"
      heroTitle="Especialização em Dor para fisios que querem entender o paciente inteiro"
      heroTitleHighlight="entender o paciente inteiro"
      heroSubtitle="Raciocínio clínico em dor aguda e crônica, modelo biopsicossocial e intervenções com base em evidência, para você sair do protocolo e entrar na decisão."
      promessas={[
        "Avaliar a dor com base em mecanismos, não em rótulos",
        "Aplicar o modelo biopsicossocial sem cair no genérico",
        "Conduzir educação em dor que realmente muda o paciente",
        "Integrar exercício, terapia manual e abordagem cognitiva",
      ]}
      personas={[
        {
          titulo: "Fisio que atende dor crônica",
          desc: "Que quer parar de tratar só sintoma e começar a tratar mecanismo + comportamento.",
        },
        {
          titulo: "Fisio em consultório",
          desc: "Que precisa de raciocínio robusto para casos complexos que ninguém mais resolveu.",
        },
        {
          titulo: "Fisio em formação contínua",
          desc: "Que quer referência científica atualizada e nome dos maiores pesquisadores do Brasil.",
        },
      ]}
      coordenadorNome="Rafael Alaiti"
      coordenadorFoto={rafaelFoto.url}
      coordenadorQuote="Dor não se trata com receita, se trata com raciocínio. E raciocínio se aprende com método."
      coordenadorBio="Coordenador da especialização em Dor da FEO. Doutor em Ciências pela USP, com mais de 60 publicações científicas em dor crônica, mecanismos da dor e prática baseada em evidências. Referência nacional em ensino de dor para fisioterapeutas."
      ementaSubtitle="Grade completa, professores e cronograma da especialização em Dor para Fisioterapeutas."
      whatsappUrl="https://nimble.li/o9yokpkm"
    />
  );
}
